import BaseValidator from 'services/validations/base-validator';

export default class PlayersNotDuplicatedValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {ruleItem, ruleName} = this.dependencies;

        const playerIds: string[] = [];

        if (ruleItem.isStatementTypePlayer()) {
            playerIds.push(ruleItem.getKeyPlayer());
        }

        ruleItem.getBoostStatements().map((boostStatement) => {
            boostStatement.isBoostForPlayer() && playerIds.push(boostStatement.getBoostedPlayer());
        });

        if (playerIds.length > arrayUnique(playerIds).length) {
            this.addError(`Players cannot be duplicated in ${ruleName}.`);
        }
    }
}
